import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Avatar,
  Paper,
  Stack,
  Popover,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "../../Images/logo.png";
import { useNavigate } from "react-router-dom";
import { LuShoppingCart } from "react-icons/lu";
import Badge from "@mui/material/Badge";
import axios from "axios";

const Header = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [count, setCount] = useState(0);
  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storedAccessToken = localStorage.getItem("AccessToken");

    if (storedUsername) setUsername(storedUsername);
    if (storedAccessToken) setAccessToken(storedAccessToken);
  }, []);

  useEffect(() => {
    const fetchCount = async () => {
      const userID = localStorage.getItem("userId");
      console.log("UserID:", userID);
      if (!userID) return;
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_KEY}/cart/count?userID=${userID}`
        );
        // const response = await axios.get(`http://localhost:8000/cart/count?userID=${userID}`);
        console.log("Fetched count:", response.data);
        setCount(response.data);
      } catch (error) {
        console.error("Error fetching favorite count", error);
        if (error.response) {
          console.error("Response data:", error.response.data);
        }
      }
    };
    fetchCount();
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    )
      return;
    setDrawerOpen(open);
  };

  const getUserInitial = () => {
    return username ? username.charAt(0).toUpperCase() : "U";
  };

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleLogout = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("userId");
    localStorage.removeItem("selectedImageUrl");
    setUsername("");
    handlePopoverClose();
    navigate(`/${accessToken}/login`);
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "rgba(60, 60, 60, 0.8)",
          borderRadius: "30px",
          maxWidth: { xs: "95%", sm: "80%", md: "90%", lg: "90%" },
          height: { xs: "60px", sm: "60px", md: "50px", lg: "60px" },
          margin: "auto",
          top: "20px",
          left: 0,
          right: 0,
          boxShadow: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.3s ease",
        }}
      >
        <Toolbar
          sx={{
            minHeight: "80px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            px: 2,
          }}
        >
          {/* Logo */}
          <Box
            component="img"
            src={Logo}
            alt="Logo"
            onClick={() => navigate(`/${accessToken}/`)}
            sx={{
              height: { xs: "40%", sm: "40%", md: "40%", lg: "60%" },
              cursor: "pointer",
              marginLeft: "12px",
            }}
          />

          {/* Desktop Navigation */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 4,
              ml: "4vw",
              flexGrow: 1,
              justifyContent: "flex-end",
              alignItems: "center",
              paddingRight: "20px",
            }}
          >
            {["Home", "About us", "Contact us", "Products","Skin-Tone Analyzer"].map(
              (item, index) => (
                <Button
                  key={index}
                  sx={{
                    color: "white",
                    fontSize: { xs: "14px", lg: "16px" },
                    textTransform: "none",
                    fontWeight: "bold",
                    fontFamily: "Roboto",
                    "&:hover": {
                      backgroundColor: "transparent",
                      textDecoration: "none",
                    },
                  }}
                  onClick={() => navigate(`/${accessToken}/${item}`)}
                >
                  {item}
                </Button>
              )
            )}
            <IconButton onClick={() => navigate(`/${accessToken}/favourites`)}>
              <Badge
                badgeContent={count > 99 ? "99+" : count}
                color="primary"
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: "#A41847",
                    color: "white",
                  },
                }}
              >
                <LuShoppingCart
                  style={{
                    fontSize: "25px",
                    cursor: "pointer",
                    color: "white",
                  }}
                  onClick={() => navigate(`/${accessToken}/${"cart"}`)}
                />
              </Badge>
            </IconButton>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {username ? (
                <>
                  <Avatar
                    onClick={handleAvatarClick}
                    sx={{
                      width: { xs: 34, sm: 36, md: 30, lg: 36 },
                      height: { xs: 0, sm: 36, md: 30, lg: 36 },
                      bgcolor: "#e91e63",
                      cursor: "pointer",
                      fontFamily: "Roboto",
                      fontWeight: "bold",
                      fontSize: {
                        xs: "14px",
                        sm: "14px",
                        md: "14px",
                        lg: "16px",
                      },
                    }}
                  >
                    {getUserInitial()}
                  </Avatar>

                  {/* Popover */}
                  <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                    sx={{ mt: 1 }}
                  >
                    <Paper
                      sx={{
                        width: 150,
                        borderRadius: 1,
                        backgroundColor: "#a41847",
                        color: "white",
                      }}
                    >
                      <Stack
                        divider={
                          <Divider
                            flexItem
                            sx={{ backgroundColor: "rgba(255,255,255,0.1)" }}
                          />
                        }
                      >
                        <Button
                          fullWidth
                          onClick={handleLogout}
                          sx={{
                            color: "white",
                            py: 1,
                            textAlign: "center",
                            fontFamily: "Roboto",
                            textTransform: "none",
                            fontWeight: "bold",
                            backgroundColor: "#ff0000",
                            "&:hover": {
                              backgroundColor: "#cc0000",
                            },
                          }}
                        >
                          Logout
                        </Button>
                      </Stack>
                    </Paper>
                  </Popover>
                </>
              ) : (
                <Button
                  sx={{
                    display: { xs: "none", md: "flex" },
                    color: "white",
                    fontSize: { xs: "14px", lg: "16px" },
                    textTransform: "none",
                    fontWeight: "bold",
                    fontFamily: "Roboto",
                    "&:hover": {
                      backgroundColor: "transparent",
                      textDecoration: "none",
                    },
                  }}
                  onClick={() => navigate(`/${accessToken}/login`)}
                >
                  Sign up/Login
                </Button>
              )}
            </Box>
          </Box>

          {/* Mobile Menu Icon */}
          <IconButton
            sx={{
              display: { xs: "block", md: "none" },
              color: "white",
              ml: 1,
            }}
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            backgroundColor: "#272727",
            height: "100vh",
            color: "white",
            textAlign: "center",
            pt: 2,
          },
        }}
      >
        <List>
          {username && (
            <Avatar
              sx={{
                marginLeft: "15px",
                width: { xs: 34, sm: 36, md: 30, lg: 36 },
                height: { xs: 34, sm: 36, md: 30, lg: 36 },
                bgcolor: "#e91e63",
                cursor: "pointer",
                fontFamily: "Roboto",
                fontWeight: "bold",
                fontSize: {
                  xs: "14px",
                  sm: "14px",
                  md: "14px",
                  lg: "16px",
                },
              }}
            >
              {getUserInitial()}
            </Avatar>
          )}
          {["Home", "About us", "Contact us", "Products","Skin-Tone Analyzer"].map((item, index) => (
            <ListItem
              button
              key={index}
              onClick={() => navigate(`/${accessToken}/${item}`)}
            >
              <ListItemText primary={item} />
            </ListItem>
          ))}
          {username ? (
            <ListItem button key={"logoutMobile"} onClick={handleLogout}>
              <ListItemText primary={"logout"} />
            </ListItem>
          ) : (
            <ListItem
              button
              key={"loginSignMobile"}
              onClick={() => navigate(`/${accessToken}/login`)}
            >
              <ListItemText primary={"Signup/Login"} />
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  );
};

export default Header;
